import axios from 'axios';
import config from 'config';

const api = axios.create({
  baseURL: config.api.endpoint,
  headers: { 'Accept-Language': 'de' },
});

export default api;
